import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {DocumentType} from 'types/documents';
import {request} from 'utils/request';
import {PdfFilenameElementOption} from './types';

export type PdfFilenameSettingsFormFields = {
    pdfFilenameClient: PdfFilenameElementOption[];
    pdfFilenameEmployee: PdfFilenameElementOption[];
};

export type PdfFilenameSettingsSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type PdfFilenameSettingsErrorResponse = Api.Response.Failure<{
    [K in DocumentType]: boolean;
}>;

export const usePutPdfFilenameSettingsEdit = (): UseMutationResult<
    PdfFilenameSettingsSuccessResponse,
    PdfFilenameSettingsErrorResponse,
    {
        mid: string;
        pdfFilenameClient: PdfFilenameElementOption[];
        pdfFilenameEmployee: PdfFilenameElementOption[];
    }
> => {
    const locale = useLocale();

    return useMutation(({mid, pdfFilenameClient, pdfFilenameEmployee}) =>
        request({
            formData: {
                pdfFilenameClient,
                pdfFilenameEmployee,
            },
            locale,
            method: 'PUT',
            uri: `/api/partner/${mid}/document/pdf-filename-settings/`,
        }),
    );
};
